<template>
  <div>
    <button class="btn btn-primary mb-3" @click.prevent="openModal">+ Upload file</button>
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="modalStatus == 0">
          Upload attachment file
          <!-- Upload tệp đính kèm -->
        </div>
        <div v-else>
          Edit attachment file
          <!-- Edit tệp đính kèm -->
        </div>
      </template>
      <form autocomplete="off">
         <b-row class="mb-4">
            <b-col cols="12">
              <b-form-file
                v-if="modalStatus == 0"
                class="mb-4"
                v-model="tepdinhkemfile"
                placeholder="Click here to upload attachment file"
                browse-text="..."
                multiple
              ></b-form-file>
              <b-form-input v-else v-model="attachItem.name" disabled></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Date
                <!-- Ngày văn bản -->
              </label>
            </b-col>
            <b-col cols="3">
              <vue-datepicker-local style="width: 100%"
                      v-model="attachItem.ngayvanban"
                      :local="local"
                      clearable
                      format="DD/MM/YYYY"/>
            </b-col>
            <b-col cols="2">
              <label class="mr-2">
                Note
                <!-- Ghi chú -->
              </label>
            </b-col>
            <b-col cols="3">
              <b-form-input v-model="attachItem.detail"></b-form-input>
            </b-col>
          </b-row>
          <div class="form-inline">
            <div style="flex-grow: 1"></div>
            <b-button v-if="modalStatus == 0" class="mr-3" @click.prevent="uploadFile" variant="info">
              <i class="fas fa-save mr-2"></i>
              Save
              <!-- Lưu -->
            </b-button>
            <b-button v-else class="mr-3" @click.prevent="updateFile" variant="info">
              <i class="fas fa-save mr-2"></i>
              Update
              <!-- Cập nhật -->
            </b-button>
            <b-button variant="secondary" @click="closeModal">
              <i class="fas fa-times mr-2"></i>
              Close
              <!-- Đóng -->
            </b-button>
          </div>
      </form>
    </b-modal>

    <b-table
      bordered
      head-variant="dark"
      hover
      responsive
      striped
      small
      sticky-header="450px"
      table-variant="light"
      :fields="fields"
      :items="items"
    >
      <template v-slot:cell(name)="data">
        <a :href="attach_url + data.item.name" target="_blank">{{data.item.name}}</a>
      </template>
      <template v-slot:cell(ngayvanban)="data">
        <span> {{ data.item.ngayvanban | moment('DD/MM/YYYY')}} </span>
      </template>
      <template v-slot:cell(action)="data">
        <b-link class="text-primary mr-2" href="#" @click="openUpdateModal(data)">
          <i class="fas fa-pencil-alt"></i>
        </b-link>
        <b-link class="text-danger mr-2" href="#" @click.prevent="deleteItem(data)">
          <i class="fas fa-trash"></i>
        </b-link>
        <!-- <button class="btn btn-info mr-1" @click="openUpdateModal(data)">
              <i class="fas fa-pencil-alt"></i>
        </button>
        <button class="btn btn-danger" @click="deleteItem(data)">
          <i class="fas fa-trash-alt"></i>
        </button> -->
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
import VueDatepickerLocal from "vue-datepicker-local";

export default {
  name: "ContractAttach",
  props: ["item"],
  components: {
    VueDatepickerLocal,
  },

  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Attachment file",
          // label: "Tệp đính kèm",
        },
        {
          key: "ngayvanban",
          label: "Date",
          // label: "Ngày văn bản",
        },
        {
          key: "detail",
          label: "Note",
          // label: "Ghi chú",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "70px !important" },
        },
      ],

      attachItem: {
        id: 0,
        name: '',
        ngayvanban: "",
        detail: '',
        customerContractId: 0,
      },

      modalStatus: 0,
      items: [],
      attach_url: `../attach/customercontract/${this.item.id}/`,
      tepdinhkemfile: null,
      modalShow: false,
      index: null,

      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.item != null) {
        axios
          .get(`/api/customercontractattach/${this.item.id}`)
          .then((res) => {
            this.items = res.data;
          })
          .catch((err) => {
            alert(err);
          });
      }
    },

    uploadFile() {
      const formData = new FormData();
      for (var i = 0; i < this.tepdinhkemfile.length; i++) {
        formData.append("tepdinhkemfile", this.tepdinhkemfile[i]);
      }

      formData.append(
          "Ngayvanban",
          this.attachItem.ngayvanban == ""
            ? ""
            : new Date(this.attachItem.ngayvanban).toUTCString()
      );

      formData.append("Detail", this.attachItem.detail);
      formData.append("customerContractId", this.item.id);

      axios
        .post("/api/customercontractattach", formData)
        .then((res) => {
          for (var i = 0; i < res.data.length; i++) {
            this.items.push(res.data[i]);
          }

          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/customercontractattach/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    updateFile(bvModalEvt) {
      this.attachItem.customerContractId = this.item.id;
      axios
        .put(`/api/customercontractattach/${this.item.id}`, this.attachItem)
        .then((res) => {
          this.items[this.index] = JSON.parse(JSON.stringify(this.attachItem));
          const temp = JSON.parse(JSON.stringify(this.items));
          this.items = JSON.parse(JSON.stringify(temp));

          this.index = null;

          this.$toast.success("Cập nhật thành công !", "Thành công", {timeout: 3000});
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    openModal() {
      this.modalStatus = 0;
      this.modalShow = true;
    },

    openUpdateModal(data) {
      this.attachItem = JSON.parse(JSON.stringify(data.item));
      this.index = data.index;
      this.modalStatus = 1;
      this.modalShow = true;
    },

    closeModal() {
      this.attachItem.tepdinhkemfile = null;
      this.attachItem.ngayvanban = "";
      this.attachItem.detail = '';
      this.modalShow = false;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
